/* eslint-disable @typescript-eslint/no-unused-vars */
// My Component

import { useState, useEffect, FormEvent } from 'react';
import { useHistory } from 'react-router';
import { FocusedInputShape } from 'react-dates';
import ButtonSubmit from './ButtonSubmit';
import moment from 'moment';
//import BusDatesRangeInput from './BusDatesRangeInput';
import BusCityInput from './BusCityInput';
import BusDateSingleInput from './BusDateSingleInput';

import {
  fetchBusCitiesAsync,
  fetchBusListAsync,
} from 'app/feature/bus/busSlice';
import { useAppDispatch, useAppSelector } from 'app/hook';
import {
  City,
  JourneyDetails,
  RoundTripJourneyDetails,
} from 'app/feature/bus/busInterfaces';

export interface DateRage {
  endDate?: any;
  startDate?: any;
  journeyDate?: any;
  returnDate?: any;
}

const BusSearchForm = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch<any>(fetchBusCitiesAsync());
  }, [dispatch]);

  const { cities, journeyDetails, roundTrip, roundTripJourneyDetails } =
    useAppSelector((state) => state.bus);

  const [busJourneyDetails, setBusJourneyDetails] = useState<JourneyDetails>();
  const [busRoundTripJourneyDetails, setBusRoundTripJourneyDetails] =
    useState<RoundTripJourneyDetails>();

  const [dateValue, setdateValue] = useState(
    journeyDetails
      ? journeyDetails.journeyDate
      : moment(new Date(), 'DD-MM-YYYY').add(1, 'days').toISOString()
  );

  const [dateRangeValue, setDateRangeValue] = useState({
    journeyDate: roundTripJourneyDetails
      ? roundTripJourneyDetails.go.journeyDate
      : moment(new Date(), 'DD-MM-YYYY').add(1, 'days').toISOString(),
    returnDate: roundTripJourneyDetails
      ? roundTripJourneyDetails.back.journeyDate
      : moment(new Date(), 'DD-MM-YYYY').add(3, 'days').toISOString(),
  });

  const [dateFocused, setDateFocused] = useState<boolean>(false);

  const originInputValue = journeyDetails?.fromCity.locName || '';
  const destinationInputValue = journeyDetails?.toCity.locName || '';

  const [origin, setOrigin] = useState<City>();
  const [destination, setDestination] = useState<City>();

  const [fieldFocused, setFieldFocused] = useState<
    FocusedInputShape | 'dropOffInput' | null
  >(null);

  const [journeyType, setJourneyType] = useState<'oneWay' | 'roundTrip'>(
    roundTrip ? 'roundTrip' : 'oneWay'
  );

  const setOriginHandler = (ev: string) => {
    cities.forEach((city: City) => city.locName === ev && setOrigin(city));
  };

  const setDestinationHandler = (ev: string) => {
    cities.forEach((city: City) => city.locName === ev && setDestination(city));
  };

  const formSubmitOneWay = (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    if (origin && destination && dateValue) {
      setBusJourneyDetails({
        fromCity: origin,
        toCity: destination,
        journeyDate: dateValue,
      });
      dispatch<any>(
        fetchBusListAsync({
          fromCityId: origin.locId,
          toCityId: destination.locId,
          depDate: dateValue,
        })
      );
      history.push('/bus');
    }
  };

  const formSubmitRoundtrip = (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    if (
      origin &&
      destination &&
      dateRangeValue.journeyDate &&
      dateRangeValue.returnDate
    ) {
      setBusRoundTripJourneyDetails({
        go: {
          fromCity: origin,
          toCity: destination,
          journeyDate: dateRangeValue.journeyDate,
        },
        back: {
          fromCity: destination,
          toCity: origin,
          journeyDate: dateRangeValue.returnDate,
        },
      });
      dispatch<any>(
        fetchBusListAsync({
          fromCityId: origin.locId,
          toCityId: destination.locId,
          depDate: dateRangeValue.journeyDate,
        })
      );
      history.push('/bus');
    }
  };

  // useEffect(() => {
  //   if (roundTrip) {
  //     if (
  //       userInput?.fromCity &&
  //       userInput?.toCity &&
  //       userInput.journeyDate &&
  //       userInput.roundTrip
  //     ) {
  //       dispatch(addUserInput(userInput));
  //       history.push("/bus");
  //     }
  //   } else {
  //     if (userInput?.fromCity && userInput?.toCity && userInput.journeyDate) {
  //       dispatch(addUserInput(userInput));
  //       history.push("/bus");
  //     }
  //   }
  // }, [userInput]);

  const renderRadioBtn = () => {
    return (
      <div className=" py-5 [ nc-hero-field-padding ] flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:space-x-10 border-b border-neutral-100 dark:border-neutral-800">
        <div className="flex  items-center">
          <input
            id="same-drop-off"
            name="drop-off-type"
            type="radio"
            value="same"
            className="focus:ring-primary-500 h-4 w-4 text-primary-500 border-neutral-300"
            checked={journeyType === 'oneWay'}
            onChange={(e) => {
              setJourneyType(e.currentTarget.value as 'oneWay');
            }}
          />
          <label
            htmlFor="same-drop-off"
            className="ml-2 sm:ml-3 block text-sm font-medium text-gray-700 dark:text-neutral-300"
          >
            One Way
          </label>
        </div>
        <div className="flex items-center">
          <input
            id="different-drop-off"
            name="drop-off-type"
            value="different"
            type="radio"
            className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
            checked={journeyType === 'roundTrip'}
            onChange={(e) => {
              setJourneyType(e.currentTarget.value as 'roundTrip');
            }}
          />
          <label
            htmlFor="different-drop-off"
            className="ml-2 sm:ml-3 block text-sm font-medium text-gray-700 dark:text-neutral-300"
          >
            Round Trip
          </label>
        </div>
      </div>
    );
  };

  const renderOneWayForm = () => {
    return (
      <form className="flex flex-col md:flex-row" onSubmit={formSubmitOneWay}>
        <BusCityInput
          onInputDone={() => setFieldFocused('dropOffInput')}
          originInputValue={originInputValue}
          city={cities}
          onChange={(ev) => setOriginHandler(ev)}
          placeHolder="From"
          desc="Your Origin"
        />

        <BusCityInput
          onInputDone={() => setFieldFocused('startDate')}
          originInputValue={destinationInputValue}
          city={cities}
          onChange={(ev) => setDestinationHandler(ev)}
          placeHolder="To"
          desc="Your Destination City"
        />

        <BusDateSingleInput
          defaultValue={dateValue}
          defaultFocus={dateFocused}
          onChange={(date) => setdateValue(date)}
          onFocusChange={(focus: boolean) => {
            setDateFocused(focus);
          }}
        />

        {/* BUTTON SUBMIT OF FORM */}
        <div className=" px-4 py-4">
          <ButtonSubmit />
        </div>
      </form>
    );
  };

  const renderRoundTrip = () => {
    return (
      <form
        onSubmit={formSubmitRoundtrip}
        className="w-full relative rounded-3xl shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-900"
      >
        <div className=" flex flex-col md:flex-row md:items-center w-full rounded-full [ nc-divide-field ] ">
          <div className="relative flex flex-col nc-flex-2-auto [ nc-divide-field ] ">
            <BusCityInput
              onInputDone={() => setFieldFocused('dropOffInput')}
              originInputValue={originInputValue}
              city={cities}
              autoFocus={fieldFocused === 'dropOffInput'}
              onChange={(ev) => setOriginHandler(ev)}
              placeHolder="From"
              desc="Your Origin"
            />

            <BusCityInput
              onInputDone={() => setFieldFocused('startDate')}
              originInputValue={destinationInputValue}
              city={cities}
              onChange={(ev) => setDestinationHandler(ev)}
              placeHolder="To"
              desc="Your Destination City"
            />
          </div>

          {/* <BusDatesRangeInput
            defaultDateValue={dateRangeValue}
            onChange={(data) => setDateRangeValue(data)}
          /> */}

          <div className="px-4 py-3">
            <ButtonSubmit />
          </div>
        </div>
      </form>
    );
  };

  return (
    <div className="w-full">
      <div className="w-full relative mt-8 rounded-3xl shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-900">
        {renderRadioBtn()}
        {journeyType === 'oneWay' && renderOneWayForm()}
        {journeyType === 'roundTrip' && renderRoundTrip()}
      </div>
    </div>
  );
};

export default BusSearchForm;
